import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { AdmissionsAreaService } from '../admissions-area.service';
import { AdmissionsAcceleratorsService } from './admissions-accelerators.service';
import { AdmissionsAcceleratorsTab1Part } from './tabs/tab-1/admissions-accelerators-tab-1.part';
import { AdmissionsAcceleratorsTab2Part } from './tabs/tab-2/admissions-accelerators-tab-2.part';
import { AdmissionsAcceleratorsViewsPart } from './views/accelerators-views.part';

@Component({
	selector: 'admissions-accelerators-page',
	standalone: true,
	imports: [
		AdmissionsAcceleratorsViewsPart,
		AdmissionsAcceleratorsTab1Part,
		AdmissionsAcceleratorsTab2Part,
		PageTab1Directive,
		PageTab2Directive,
		PageTab3Directive,
		PageTabsWidget,
		TrimesterDroplistWidget,
		DroplistWidget, ToolbarWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './admissions-accelerators.page.html',
})
export class AdmissionsAcceleratorsPage implements OnInit {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Admissions;
	public admissionsService = inject(AdmissionsAreaService);


	constructor(public pageService: AdmissionsAcceleratorsService) { }


	async ngOnInit() {
		await this.admissionsService.loadAdmissionsData();
	}

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}